import { render, staticRenderFns } from "./ypcxList.vue?vue&type=template&id=6b829bb5&scoped=true"
import script from "./ypcxList.vue?vue&type=script&lang=js"
export * from "./ypcxList.vue?vue&type=script&lang=js"
import style0 from "./ypcxList.vue?vue&type=style&index=0&id=6b829bb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b829bb5",
  null
  
)

export default component.exports